import { defineMessages } from 'react-intl';

export default defineMessages({
  timeLeft: 'Time left',
  passedOn: 'Passed on',
  executedOn: 'Executed on',
  expiredOn: 'Expired on',
  failedOn: 'Failed on',
  cancelledOn: 'Cancelled on',
  invalidFormat: 'Invalid format',
});
